/**
 * Resolve profile image URL for display (API host + stored path).
 */
export const getProfileImageUrl = (profileImage) => {
  if (!profileImage) return null;
  if (/^https?:\/\//i.test(profileImage)) return profileImage;
  const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  const path = profileImage.startsWith('/') ? profileImage : `/${profileImage}`;
  return `${base}${path}`;
};
